import $ from "jquery";

const header = () => {
    const init = () => {
        execute()
    }

    const execute = () => {
        const el = {
            main: '.js-header'
        }
        if ($(el.main).length === 0) return

        const listActive = [
            "page-spesific-kontakt",
            "error404"
        ]

        const $header = $(el.main);
        const bodyHasActive = listActive.some(function (cls) {
            return $('body').hasClass(cls);
        });

        if (bodyHasActive) {
            $header.addClass('Active');
            return;
        } else {
            $(window).on('scroll', function () {
                const offset = $(window).scrollTop();
                if (offset && offset > 0) {
                    $header.addClass('Active');
                } else {
                    $header.removeClass('Active');
                }
            });
        }


    }
    init()
}

try {
    header()
} catch (error) {
    console.error('header', error)
}